import { useEffect } from 'react'

export const usePreApproved = setDataModal => {
  useEffect(() => {
    setDataModal(null)
  }, [setDataModal])
}
